module.exports = __webpack_public_path__ + "images/category_lp/smartphone/assessment_achievements/5_a581b0c491659f511b55539b172a989a.jpg";